// Copyright (c) 2017 Deere & Company

import ClaimSearchResult from '@deere/cps-it.warranty-model-factory/lib/claim-search-result';
import t from 'tcomb';

const Report = t.list(ClaimSearchResult, 'Report');

export const getDefaultState = () => new Report([]);

export default Report;



// WEBPACK FOOTER //
// ./src/reports/advanced-claim-summary/state/report.js